import { handleEvent, parseSettings, track } from '@cwp/utils'

const { floor, random } = Math
const TOKEN = floor(random() * 10000)
let count = 0

function getSettings (element, options) {
  return parseSettings(
    element.getAttribute('data-settings'),
    options
  )
}

export default class Component {
  constructor (element, options = {}) {
    if (element) {
      this.id = `${TOKEN}-${count++}`
      this.element = element
      this.settings = getSettings(element, options)

      // add instance to element
      this.element._component = this
      this.init()
    }
  }

  init () {
    track.warn(`no init method provided for component ${this.id}`, this.element)
  }

  bind (eventName, selector, handler) {
    if (this.element) {
      return handleEvent(
        this.element,
        eventName,
        selector,
        handler
      )
    } else {
      throw new Error('unable to bind events to this component')
    }
  }
}
